const ERROR_PATTERN = /error|failed|exception|traceback|panic|fatal/i;
const CONTEXT_AFTER = 2;
const FALLBACK_LINES = 10;

export function extractErrorSummary(
  logLines: string[],
  maxLines = 15,
): string[] {
  if (logLines.length === 0) return [];

  const keep = new Set<number>();
  logLines.forEach((line, i) => {
    if (ERROR_PATTERN.test(line)) {
      for (let j = i; j <= Math.min(i + CONTEXT_AFTER, logLines.length - 1); j++) {
        keep.add(j);
      }
    }
  });

  if (keep.size === 0) {
    return logLines.slice(-FALLBACK_LINES);
  }

  const indices = Array.from(keep).sort((a, b) => a - b).slice(-maxLines);
  return indices.map((i) => logLines[i]);
}
